import * as React from 'react';

var _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var SvgLocation = function SvgLocation(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        "aria-hidden": "true",
        className: "location_svg__icon location_svg__icon--location"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 1.47a5.98 5.98 0 0 0-5.98 5.98c0 .642.256 1.61.727 2.81.463 1.174 1.1 2.49 1.79 3.793 1.26 2.38 2.674 4.675 3.462 5.92.79-1.245 2.203-3.54 3.463-5.92.69-1.304 1.327-2.62 1.79-3.795.472-1.198.728-2.167.728-2.807A5.982 5.982 0 0 0 12 1.469Zm-5.269.712A7.45 7.45 0 0 1 19.45 7.451c0 .935-.348 2.123-.83 3.346-.49 1.246-1.155 2.615-1.858 3.943-1.407 2.657-2.995 5.2-3.73 6.348a1.225 1.225 0 0 1-2.063 0c-.735-1.148-2.323-3.69-3.73-6.347-.703-1.328-1.367-2.697-1.858-3.944-.482-1.223-.83-2.41-.83-3.346M6.73 2.182a7.45 7.45 0 0 0-2.181 5.27Zm1.106 4.92a4.163 4.163 0 1 1 8.326 0 4.163 4.163 0 0 1-8.326 0ZM12 4.408a2.694 2.694 0 1 0 0 5.388 2.694 2.694 0 0 0 0-5.388Zm4.166 15.073a.735.735 0 0 1 .794-.67c1.905.16 3.546.412 4.728.733.585.159 1.099.345 1.483.57.328.191.829.568.829 1.192 0 .443-.26.76-.488.955-.233.198-.535.357-.852.487-.643.265-1.528.487-2.568.667C18 23.78 15.14 24 12 24c-3.14 0-6-.22-8.092-.585-1.04-.18-1.925-.402-2.568-.667-.318-.13-.619-.289-.852-.487C.26 22.067 0 21.749 0 21.306c0-.622.498-.999.824-1.19.383-.225.895-.412 1.476-.57 1.174-.321 2.805-.573 4.698-.735a.735.735 0 1 1 .126 1.464c-1.852.158-3.384.4-4.437.688-.43.117-.751.235-.974.343.054.026.116.054.186.083.498.205 1.262.405 2.26.579 1.986.345 4.759.563 7.841.563s5.855-.218 7.84-.563c.999-.174 1.763-.374 2.26-.579.07-.029.133-.056.186-.082a5.852 5.852 0 0 0-.983-.345c-1.06-.288-2.603-.53-4.467-.687a.735.735 0 0 1-.67-.794Zm6.42 2.014-.008-.009.008.01Zm-21.164-.01-.008.01.008-.01Z",
        clipRule: "evenodd"
    })));
};

export { SvgLocation as default };
//# sourceMappingURL=location-6e4fdadc.js.map
